import { sortBy } from "../filters";
import { columnConfigs, employeeDisplayProperties, } from "./config";
export { columnConfigs, employeeDisplayProperties } from "./config";
export function mergeWithDefaultColumns(columns, defaultColumns) {
    const allowedTypes = new Set(defaultColumns.map((column) => column.type));
    const allowedColumns = columns.filter((column) => allowedTypes.has(column.type));
    const knownTypes = new Set(columns.map((column) => column.type));
    const missingColumns = defaultColumns.filter((defaultColumn) => !knownTypes.has(defaultColumn.type));
    const allColumns = [...missingColumns, ...allowedColumns]; // adding missing columns at the beginning so that their order value takes precedence over existing columns.
    // Update new order values
    const sortedColumns = sortBy(allColumns, (col) => col.order ?? Number.MAX_SAFE_INTEGER, "ascending");
    return sortedColumns.map((column, order) => {
        return { ...column, order };
    });
}
export function filterForPermissions(checkPermission, columnOptions) {
    return columnOptions.filter((column) => {
        const config = columnConfigs[column.type];
        return !config.requiredPermissions || config.requiredPermissions.some(checkPermission);
    });
}
/**
 * checks if there is any column that satisfies all required permissions
 */
export function hasAnyRequiredPermissions(checkPermission) {
    return employeeDisplayProperties.some((type) => {
        const config = columnConfigs[type];
        if (!config.requiredPermissions || !config.requiredPermissions.length)
            return true;
        return config.requiredPermissions.every(checkPermission);
    });
}
export function filterForEnabled(columnOptions) {
    return columnOptions.filter((column) => !column.disabled && !columnConfigs[column.type].disabled);
}
export function getRequiredContext(columnOptions) {
    const requirements = new Set();
    for (const column of columnOptions) {
        const config = columnConfigs[column.type];
        if (config.requiredContext) {
            for (const requirement of config.requiredContext) {
                requirements.add(requirement);
            }
        }
    }
    return requirements;
}
export function precompileColumnOptions(context, columnOptions) {
    const compiledOptions = [];
    for (const option of columnOptions) {
        const config = columnConfigs[option.type];
        const precompiler = config.preCompile;
        if (precompiler) {
            const options = precompiler(context);
            compiledOptions.push(...options);
        }
        else {
            compiledOptions.push(option);
        }
    }
    return compiledOptions;
}
export function getTable(contexts, columns) {
    const table = new Array(contexts.length);
    for (const i in contexts) {
        table[i] = new Array(columns.length);
        for (const j in columns) {
            const column = columns[j];
            const getValue = columnConfigs[column.type].getValue;
            table[i][j] = getValue ? getValue(contexts[i], column) : "Nicht unterstützt";
        }
    }
    return table;
}
export function getTableHeaders(columns) {
    return columns.map((column) => columnConfigs[column.type].getHeader());
}
export function getTableSubHeaders(context, columns) {
    return columns.map((column) => {
        const getSubHeaderFn = columnConfigs[column.type].getSubHeader;
        return getSubHeaderFn ? getSubHeaderFn(context, column) : "";
    });
}
export function serializeColumOptions(options) {
    return encodeURIComponent(btoa(JSON.stringify(options)));
}
export function deserializeColumOptions(options) {
    if (!options)
        return [];
    return JSON.parse(atob(decodeURIComponent(options)));
}
//# sourceMappingURL=employee-table.js.map